<template>
    <div>
      <!-- Principle Investigator -->
      <div class="memory-box">
        <div class="top-bar">Principle Investigator</div>
        <el-table :data="[principleInvestigator]" border style="width: 100%">
          <el-table-column label="Photo" width="200">
            <template #default="{ row }">
              <img :src="row.photo" alt="Photo" style="height: 150px; width: 150px;" />
            </template>
          </el-table-column>
          <el-table-column label="Information">
            <template #default="{ row }">
              <div>
                <p><strong>{{ row.name }}</strong></p>
                <p>{{ row.position }}</p>
                <p>{{ row.school }}</p>
                <p>{{ row.address }}</p>
                <p>Email: {{ row.email }}</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
      <!-- Current Students -->
      <div class="memory-box">
        <div class="top-bar">Current Students</div>
        <el-table :data="currentStudents" border style="width: 100%">
          <el-table-column label="Photo" width="200">
            <template #default="{ row }">
              <img :src="row.photo" alt="Photo" style="height: 150px; width: 150px;" />
            </template>
          </el-table-column>
          <el-table-column label="Name">
            <template #default="{ row }">
              <strong>{{ row.name }}</strong>
            </template>
          </el-table-column>
          <el-table-column label="Position">
            <template #default="{ row }">
              {{ row.position }}
            </template>
          </el-table-column>
          <el-table-column label="Email">
            <template #default="{ row }">
              {{ row.email }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'team',
    data() {
      return {
        principleInvestigator: {
          photo: "../assets/teacher.jpg",
          name: "Xiangyu Li",
          position: "PhD, Bioinformatics, Associate Professor",
          school: "School of Software Engineering, Beijing Jiaotong University",
          address: "Room 709, Yifu Building, Beijing Jiaotong University, Beijing 100044, China",
          email: "lixiangyu@bjtu.edu.cn",
        },
        currentStudents: [
          {
            photo: "../assets/xhj.jpg",
            name: "Huijie Xue (薛辉杰)",
            position: "Master Student",
            email: "22121756@bjtu.edu.cn",
          },
          {
            photo: "../assets/wjx.jpg",
            name: "Jinxia Wang (王金霞)",
            position: "Master Student",
            email: "wangjinxia0116@163.com",
          },
          {
            photo: "../assets/wc_2.jpg",
            name: "Chen Wang (王琛)",
            position: "Master Student",
            email: "1426822528@qq.com",
          },
          {
            photo: "../assets/zhangjianxing.jpg",
            name: "Jianxing Zhang (张建兴)",
            position: "Master Student",
            email: "2146015487@qq.com",
          },
          {
            photo: "../assets/yaozhuoxing.jpg",
            name: "Zhuoxin Yao (姚卓鑫)",
            position: "Master Student",
            email: "2362063568@qq.com",
          },
          {
            photo: "../assets/zhaorui.jpg",
            name: "Rui Zhao (赵蕊)",
            position: "Master Student",
            email: "1836162874@qq.com",
          },
          {
            photo: "../assets/lcc.jpg",
            name: "Chengcheng Liu (刘铖铖)",
            position: "PhD Student, Joint Ph.D. Student with UT Dallas",
            email: "chengcheng.liu@utdallas.edu",
          },
        ],
      };
    },
  };
  </script>
  
  <style>
  .memory-box {
    margin: 20px 0;
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 8px;
  }
  .top-bar {
    background-color: #005BAC;
    color: white;
    padding: 10px;
    font-size: 20px;
    font-weight: bold;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components2/team.vue